import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {

  const messageService = inject(MessageService);
  const translateService = inject(TranslateService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage: string;

      if (error.error instanceof ErrorEvent) {
        // Errore client-side
        errorMessage = error.error.message;
      } else {
        // Errore server-side
        switch (error.status) {
          case 400:
            errorMessage = (error.error?.response || error.error?.errorDescription) ? (error.error?.response || error.error?.errorDescription) : translateService.instant('shared_message_api.400');
            break;
          case 401:
            errorMessage = error.error?.response ?? translateService.instant('shared_message_api.401');
            break;
          case 403:
            errorMessage = error.error?.response ?? translateService.instant('shared_message_api.403');
            break;
          case 404:
            errorMessage = error.error?.response ?? translateService.instant('shared_message_api.404');
            break;
          case 500:
            errorMessage = error.error?.response ?? translateService.instant('shared_message_api.500');
            break;
          default:
            errorMessage = `Errore ${error.status}: ${error.error?.response ?? translateService.instant('shared_message_api.default_error')}`;
        }
      }

      if (error.status == 409) messageService.add({
        severity: 'warn',
        summary: 'Export dati',
        detail: "Elaborazione dati già in corso"
      });
      else messageService.add({
        severity: 'error',
        summary: translateService.instant('shared_message_api.error'),
        detail: errorMessage,
        life: 3000
      });

      return throwError(() => error);
    })
  );
};
